// extracted by mini-css-extract-plugin
export default {"title":"Account_title__HBpgF","membershipNumber":"Account_membershipNumber__S5E3Q","desktopContent":"Account_desktopContent__7iwmK"};